(function () {
  'use strict';

  var WIDTH_RE = /width/i;

  if (document.querySelector('[data-tld-optimized="on"]') &&
      window.theme && window.theme.strings) {
    window.theme.strings.sale_badge_text = 'You save';
  }

  function text(el) { return (el && el.textContent || '').trim(); }

  function handleize(s) {
    return (s || '').toString().toLowerCase().trim()
      .replace(/['"]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  function getProductData(section) {
    var node = section.querySelector('[data-product-json]');
    if (!node) return null;
    try { return JSON.parse(node.textContent); } catch (e) { return null; }
  }

  function isInStock(v) {
    return !!v && v.available === true;
  }

  
  function autoSelect(section, product) {
    if (window.TLD_DISABLE_AUTOSELECT) return;
    if (section.getAttribute('data-tld-autoselect') === 'off') return;
    if (!product || !product.variants || !product.variants.length) return;

    var variants = product.variants, i;
    var idField = section.querySelector('[name="id"][data-product-select], [data-product-select]');
    var currentId = idField ? parseInt(idField.value, 10) : null;

    var current = null;
    for (i = 0; i < variants.length; i++) {
      if (variants[i].id === currentId) { current = variants[i]; break; }
    }
    if (current && isInStock(current)) return;

    var target = null;
    for (i = 0; i < variants.length; i++) {
      if (isInStock(variants[i])) { target = variants[i]; break; }
    }
    if (!target) return;
    if (current && target.id === current.id) return;

    applyVariant(section, target);
  }

  function applyVariant(section, variant) {
    var options = [variant.option1, variant.option2, variant.option3];
    var changed = false;

    for (var pos = 1; pos <= 3; pos++) {
      var value = options[pos - 1];
      if (value === null || typeof value === 'undefined') continue;

      var radios = section.querySelectorAll(
        'input[type="radio"][data-single-option-selector][data-index="option' + pos + '"]'
      );
      if (radios.length) {
        for (var r = 0; r < radios.length; r++) {
          var match = radios[r].value === value;
          if (match && !radios[r].checked) { radios[r].checked = true; fire(radios[r]); changed = true; }
          else if (match) { radios[r].checked = true; }
        }
        continue;
      }

      var hidden = section.querySelector(
        'input[type="hidden"][data-single-option-selector][data-index="option' + pos + '"]'
      );
      if (hidden && hidden.value !== value) {
        hidden.value = value;
        syncPopout(hidden, value);
        fire(hidden);
        changed = true;
      }
    }
    return changed;
  }

  function syncPopout(hidden, value) {
    var popout = hidden.closest('[data-popout]');
    if (!popout) return;
    var label = popout.querySelector('[data-popout-text]');
    if (label) label.textContent = value;
    var items = popout.querySelectorAll('[data-popout-option]');
    for (var i = 0; i < items.length; i++) {
      var on = items[i].getAttribute('data-value') === value;
      if (on) { items[i].setAttribute('aria-current', 'true'); }
      else { items[i].removeAttribute('aria-current'); }
      var li = items[i].closest('.select-popout__item');
      if (li) li.classList.toggle('select-popout__item--current', on);
    }
  }

  function fire(el) {
    el.dispatchEvent(new Event('change', { bubbles: true }));
    el.dispatchEvent(new Event('input', { bubbles: true }));
  }

  
  function widthFirst(section) {
    var stacks = section.querySelectorAll('.product__selectors');
    for (var s = 0; s < stacks.length; s++) {
      var wrappers = stacks[s].querySelectorAll(':scope > .selector-wrapper');
      for (var w = 0; w < wrappers.length; w++) {
        var legend = wrappers[w].querySelector('.radio__legend__label, .select__label, legend');
        if (legend && WIDTH_RE.test(text(legend))) {
          wrappers[w].classList.add('tld-width-first');
          break;
        }
      }
    }
  }

  
  function placeSizeGuide(section) {
    var trigger = section.querySelector('.tld-sizechart__trigger');
    if (!trigger) return;
    var wrappers = section.querySelectorAll('.product__selectors > .selector-wrapper');
    for (var i = 0; i < wrappers.length; i++) {
      var labelEl = wrappers[i].querySelector('.radio__legend__label, .select__label, legend');
      var host = wrappers[i].querySelector('.radio__legend, .select__label, legend');
      var t = text(labelEl);
      if (host && /size/i.test(t) && !/width/i.test(t)) {
        host.classList.add('tld-has-sizeguide');
        host.appendChild(trigger);
        return;
      }
    }
  }

  
  function hideSingleOptions(section) {
    var wrappers = section.querySelectorAll('.product__selectors > .selector-wrapper');
    for (var i = 0; i < wrappers.length; i++) {
      var w = wrappers[i];
      var legend = w.querySelector('.radio__legend__label, .select__label, legend');
      if (w.querySelector('[data-swatches-container]') || (legend && /colou?r/i.test(text(legend)))) continue;
      if (!w.querySelector('[data-single-option-selector]')) continue;
      var radios = w.querySelectorAll('input[type="radio"][data-single-option-selector]');
      var count = radios.length ? radios.length
                                : w.querySelectorAll('[data-popout-option]').length;
      if (count === 1) w.classList.add('tld-option-hidden');
    }
  }

  
  function colorName(section) {
    if (section.getAttribute('data-tld-swatch-name') !== 'on') return;
    var groups = section.querySelectorAll('[data-swatches-container]');
    for (var g = 0; g < groups.length; g++) {
      (function (group) {
        var legend = group.querySelector('[data-swatches-label], .radio__legend');
        if (!legend) return;
        var out = legend.querySelector('.tld-swatch-selected');
        if (!out) {
          out = document.createElement('span');
          out.className = 'tld-swatch-selected';
          legend.appendChild(out);
        }
        var update = function () {
          var checked = group.querySelector('input[type="radio"]:checked');
          out.textContent = checked ? checked.value : '';
        };
        group.addEventListener('change', update);
        update();
      })(groups[g]);
    }
  }

  
  function buildModel(product) {
    if (!product || !product.variants || !product.variants.length) return null;
    var opts = product.options || [], colorPos = 0, sizePos = 0, i;
    for (i = 0; i < opts.length; i++) {
      var n = (opts[i] || '').toString().toLowerCase();
      if (!colorPos && /colou?r/.test(n)) colorPos = i + 1;
      else if (!sizePos && /size/.test(n) && !/width/.test(n)) sizePos = i + 1;
    }
    function optVal(v, pos) {
      if (pos === 1) return v.option1;
      if (pos === 2) return v.option2;
      if (pos === 3) return v.option3;
      return '';
    }
    var colors = {}, claimed = {}, variants = product.variants;
    for (i = 0; i < variants.length; i++) {
      var v = variants[i];
      var cval = colorPos ? optVal(v, colorPos) : '';
      if (cval == null) cval = '';
      var ch = handleize(cval);
      if (!colors[ch]) colors[ch] = { value: cval, inStock: 0, total: 0, media: {}, sizes: {} };
      var c = colors[ch], stocked = isInStock(v);
      c.total++;
      if (stocked) c.inStock++;
      if (v.featured_media && v.featured_media.id != null) {
        c.media[v.featured_media.id] = true;
        claimed[v.featured_media.id] = true;
      }
      if (sizePos) {
        var sval = optVal(v, sizePos);
        if (sval != null && sval !== '') {
          var sh = handleize(sval);
          if (c.sizes[sh] !== true) c.sizes[sh] = stocked ? true : (c.sizes[sh] || false);
        }
      }
    }
    return { colorPos: colorPos, sizePos: sizePos, colors: colors, claimed: claimed };
  }

  // A gallery image (and its thumbnail) is hidden ONLY when its colour tag -- the
  // text after '#' in the image alt, e.g. "...#raincloud,steel-grey" -- matches no
  // live product colour, i.e. that whole colour/variant has been removed. Live
  // colours are always kept, out-of-stock ones included; the theme itself switches
  // the active image when a colour is picked.
  //
  // This runs ONCE, at init, and never toggles again while the shopper changes
  // colour. Earlier builds hid non-matching images on every `change` (by a
  // featured-media map, or per selected colour); toggling display:none on the
  // Flickity main + thumbnail sliders at runtime corrupts their cached geometry
  // (the viewport height collapses to 0 and the selected cell lands off-screen),
  // which is what made the main image disappear when switching or scrolling.
  function galleryFilter(section, model) {
    if (!model || !model.colorPos) return;            // no colour option -> nothing to prune
    var slides = section.querySelectorAll('.product-single__media-slide, .product-single__thumbnail');
    if (!slides.length) return;

    var live = model.colors || {};                    // handles of colours still on the product
    if (!Object.keys(live).length) return;

    var hidAny = false;
    for (var i = 0; i < slides.length; i++) {
      var img = slides[i].querySelector('img');
      var alt = img ? (img.getAttribute('alt') || '') : '';
      var hash = alt.indexOf('#');
      if (hash === -1) continue;                       // untagged media -> always kept
      var tags = alt.slice(hash + 1).split(',').map(handleize);
      var anyLive = false;
      for (var t = 0; t < tags.length; t++) {
        if (tags[t] && live[tags[t]]) { anyLive = true; break; }
      }
      if (!anyLive) { slides[i].classList.add('tld-media-hidden'); hidAny = true; }
    }

    // A single re-measure so the Flickity sliders drop the removed cells from
    // their geometry. Fires only at load and only if something was hidden, so
    // there is no flicker while the shopper interacts.
    if (hidAny) {
      requestAnimationFrame(function () { window.dispatchEvent(new Event('resize')); });
    }
  }

  
  function stickyBar(section) {
    var bar = section.querySelector('[data-tld-sticky-atc]');
    if (!bar) return;
    var realBtn = section.querySelector('[data-add-to-cart]');
    if (!realBtn) return;

    var stickyBtn = bar.querySelector('[data-tld-sticky-btn]');
    var stickyLabel = bar.querySelector('[data-tld-sticky-label]');
    var stickyPrice = bar.querySelector('[data-tld-sticky-price]');
    var realPrice = section.querySelector('[data-product-price]');
    var realLabel = realBtn.querySelector('[data-add-to-cart-text]');

    stickyBtn.addEventListener('click', function () {
      if (realBtn.disabled) return;
      realBtn.click();
    });

    function syncBtn() {
      var disabled = realBtn.disabled || realBtn.getAttribute('aria-disabled') === 'true';
      stickyBtn.disabled = disabled;
      bar.classList.toggle('is-soldout', disabled);
      if (stickyLabel && realLabel) stickyLabel.textContent = realLabel.textContent.trim();
    }
    function syncPrice() {
      if (stickyPrice && realPrice) stickyPrice.innerHTML = realPrice.innerHTML;
    }
    syncBtn();

    if (window.MutationObserver) {
      new MutationObserver(syncBtn).observe(realBtn, {
        subtree: true, childList: true, characterData: true,
        attributes: true, attributeFilter: ['disabled', 'aria-disabled']
      });
      if (realPrice) {
        new MutationObserver(syncPrice).observe(realPrice, {
          subtree: true, childList: true, characterData: true
        });
      }
    }

    var sentinel = section.querySelector('.product__submit__holder') || realBtn;
    if ('IntersectionObserver' in window && sentinel) {
      new IntersectionObserver(function (entries) {
        var entry = entries[0];
        var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', scrolledPast);
        bar.setAttribute('aria-hidden', scrolledPast ? 'false' : 'true');
      }, { threshold: 0 }).observe(sentinel);
    }
  }

  function wireAddon() {
    var addon = document.querySelector('[data-tld-addon]');
    if (!addon || addon.__tldWired) return;
    var check = addon.querySelector('[data-tld-addon-check]');
    var defaultId = parseInt(addon.getAttribute('data-addon-variant'), 10);
    if (!check || !defaultId) return;
    addon.__tldWired = true;

    var select = addon.querySelector('[data-tld-addon-variant-select]');
    var priceEl = addon.querySelector('[data-tld-addon-price]');
    var compareEl = addon.querySelector('[data-tld-addon-compare]');

    function selectedId() {
      if (select && select.value) return parseInt(select.value, 10);
      return defaultId;
    }

    if (select) {
      select.addEventListener('change', function () {
        var opt = select.options[select.selectedIndex];
        if (priceEl && opt) priceEl.textContent = opt.getAttribute('data-price') || priceEl.textContent;
        if (compareEl && opt) {
          var cmp = opt.getAttribute('data-compare');
          if (cmp) { compareEl.textContent = cmp; compareEl.hidden = false; }
          else { compareEl.textContent = ''; compareEl.hidden = true; }
        }
      });
    }

    var section = document.querySelector('[data-section-type="product-template"][data-tld-optimized="on"]');
    var inFlight = false;
    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('[data-add-to-cart]') : null;
      if (!btn || (section && !section.contains(btn))) return;
      if (btn.__tldBundled) { btn.__tldBundled = false; return; }
      if (!check.checked) return;

      e.preventDefault();
      e.stopImmediatePropagation();
      if (inFlight) return;
      inFlight = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: selectedId(), quantity: 1 }] })
      })['catch'](function () {})
        .then(function () {
          inFlight = false;
          btn.__tldBundled = true;
          btn.click();
        });
    }, true);
  }

  function addonWidget() {
    if (!document.querySelector('[data-tld-addon]')) return;
    wireAddon();
  }

  function initSection(section) {
    if (!section || section.__tldInit) return;
    section.__tldInit = true;
    if (section.getAttribute('data-tld-optimized') !== 'on') return;
    var product = getProductData(section);
    widthFirst(section);
    hideSingleOptions(section);
    autoSelect(section, product);
    colorName(section);
    try { galleryFilter(section, buildModel(product)); } catch (e) {}
    try { placeSizeGuide(section); } catch (e) {}
    stickyBar(section);
    try { addonWidget(); } catch (e) {}
  }

  function initAll(root) {
    var scope = root || document;
    if (scope.getAttribute && scope.getAttribute('data-section-type') === 'product-template') {
      initSection(scope);
    }
    var sections = scope.querySelectorAll('[data-section-type="product-template"]');
    for (var i = 0; i < sections.length; i++) initSection(sections[i]);
    try { addonWidget(); } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
